import { RbacNode } from '../components/admin/RbacTreeDiagram';

// Generic Color themes for system roles
export const SYSTEM_ROLE_THEMES = [
    { border: '#22d3ee', bg: 'rgba(6, 182, 212, 0.15)', shadow: 'rgba(6, 182, 212, 0.4)', text: '#ecfeff' }, // Cyan
    { border: '#a78bfa', bg: 'rgba(139, 92, 246, 0.15)', shadow: 'rgba(139, 92, 246, 0.4)', text: '#f5f3ff' }, // Purple
    { border: '#34d399', bg: 'rgba(16, 185, 129, 0.15)', shadow: 'rgba(16, 185, 129, 0.4)', text: '#ecfdf5' }, // Emerald
    { border: '#fb923c', bg: 'rgba(249, 115, 22, 0.15)', shadow: 'rgba(249, 115, 22, 0.4)', text: '#fff7ed' }, // Orange
    { border: '#f472b6', bg: 'rgba(244, 114, 182, 0.15)', shadow: 'rgba(244, 114, 182, 0.4)', text: '#fdf2f8' }, // Pink
    { border: '#fbbf24', bg: 'rgba(251, 191, 36, 0.15)', shadow: 'rgba(251, 191, 36, 0.4)', text: '#fffbeb' }, // Yellow
];

// Color themes for customer roles (green/blue focused for customer branding)
export const CUSTOMER_ROLE_THEMES = [
    { border: '#10b981', bg: 'rgba(16, 185, 129, 0.15)', shadow: 'rgba(16, 185, 129, 0.4)', text: '#ecfdf5' }, // Emerald (clientAdmin)
    { border: '#3b82f6', bg: 'rgba(59, 130, 246, 0.15)', shadow: 'rgba(59, 130, 246, 0.4)', text: '#eff6ff' }, // Blue (projectManager)
    { border: '#f59e0b', bg: 'rgba(245, 158, 11, 0.15)', shadow: 'rgba(245, 158, 11, 0.4)', text: '#fffbeb' }, // Amber (engineer)
    { border: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.15)', shadow: 'rgba(139, 92, 246, 0.4)', text: '#f5f3ff' }, // Purple (viewer)
];

/**
 * Transforms a flat RBAC role-permission map into a hierarchical tree structure for visualization.
 * 
 * @param roles Map of role names to permission arrays
 * @param collapsedRoles Set of role names that should be collapsed (hide children)
 * @param rootName Name of the root node (e.g. "AutoGain RBAC" or "Organization RBAC")
 * @returns Root RbacNode or null if roles map is invalid
 */
export const transformRbacToHierarchy = (
    roles: Record<string, string[]> | null | undefined,
    collapsedRoles: Set<string>,
    rootName: string
): RbacNode | null => {
    if (!roles) return null;

    return {
        id: 'root',
        name: rootName,
        type: 'root',
        children: Object.entries(roles).map(([role, permissions]) => ({
            id: `role-${role}`,
            name: role,
            type: 'role' as const,
            roleId: role,
            collapsed: collapsedRoles.has(role),
            children: collapsedRoles.has(role) ? [] : permissions.map(perm => ({
                id: `perm-${role}-${perm}`,
                name: perm,
                type: 'permission' as const
            }))
        }))
    };
};
